<div class="kpi-panel">
  <div class="kpi-panel__body">
    <div class="panel-header">
      <img src="assets/icon/Polygon_right.svg" alt="" />
      <span class="title">{{ 'POLYGON.POLYGON' | translate }}</span>
    </div>

    @if (store.zoneLegend().length > 0) {
      <div class="filter-item">
        <div class="color-mode-selector">
          <label class="radio-label">
            <input type="radio" name="siteMapColorMode" [checked]="!store.useZoneColors()" (change)="store.setZoneColors(false)" />
            <span class="radio-custom"></span>
            <span class="filter-label">KPI</span>
          </label>
          <label class="radio-label">
            <input type="radio" name="siteMapColorMode" [checked]="store.useZoneColors()" (change)="store.setZoneColors(true)" />
            <span class="radio-custom"></span>
            <span class="filter-label">{{ 'GLOBAL.ZONES' | translate }}</span>
          </label>
        </div>
      </div>
    }

    @if (!store.useZoneColors()) {
      <ng-select
        class="kpi-select"
        placeholder="KPI"
        [clearable]="false"
        [searchable]="false"
        [ngModel]="store.selectedKpiId()"
        (ngModelChange)="store.selectKpi($event)">
        @for (kpi of store.activeKpis(); track kpi.referentielDonneeAnalyseId) {
          <ng-option [value]="kpi.referentielDonneeAnalyseId">{{ kpi.nom }}</ng-option>
        }
      </ng-select>

      <div class="kpi-gauge">
        <div class="kpi-gauge__scale" [style.background]="gradient"></div>
        @if (store.kpiScale(); as scale) {
          @if (scale.min !== null && scale.max !== null) {
            <div class="kpi-gauge__bounds">
              <span>{{ scale.min }} {{ scale.unit }}</span>
              <span>{{ scale.max }} {{ scale.unit }}</span>
            </div>
          }
        }
      </div>
    } @else {
      <div class="color-content-separator"></div>
      <div class="zones-legend">
        @for (zone of store.zoneLegend(); track zone.zoneId; let last = $last) {
          <div class="zone-legend-item">
            <div class="zone-legend-item__color" [style.background-color]="zone.color"></div>
            <span class="zone-legend-item__name">{{ zone.name }}</span>
            @if (!last) {
              <div class="zone-legend-item__separator"></div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
